import { Link, useSearch } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';

import { useGetStudioDetails } from '~entities/studios/api/get-studio-details';
import { PaymentProcessingMethod } from '~entities/studios/model/types';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~shared/shadcn/ui/tabs';

import { ManualProcessingTab } from './manual-processing-tab';
import { PaymentProcessing } from './payment-processing';

export function PaymentProcessingPage() {
  const search = useSearch({ from: '/_auth/_layout/payment/payment-processing' });
  const { data: studioDetails, isFetching } = useGetStudioDetails();
  const method = studioDetails?.paymentProcessingMethod;
  const isManual = method === PaymentProcessingMethod.MANUAL;
  const defaultTab = isManual
    ? PaymentProcessingMethod.MANUAL
    : PaymentProcessingMethod.AUTO;
  const manualSubTab = search?.tab === 'pending' ? 'pending' : 'history';
  return (
    <>
      <Link to='/dashboard' className='mb-4 flex min-w-0 items-center gap-2'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='min-w-0 text-xl font-semibold sm:text-2xl'>
          Payment Processing
        </h2>
      </Link>
      <div className='mt-8 border-t' />
      <div className='container mx-auto py-6'>
        {isFetching ? (
          <div className='flex items-center justify-center'>
            <Loader2 className='animate-spin text-primary' />
          </div>
        ) : (
          <Tabs defaultValue={defaultTab} className='w-full'>
            <TabsList className='grid w-full max-w-md grid-cols-2'>
              <TabsTrigger
                value={PaymentProcessingMethod.AUTO}
                disabled={isManual}
              >
                Auto Processing
              </TabsTrigger>
              <TabsTrigger
                value={PaymentProcessingMethod.MANUAL}
                disabled={!isManual}
              >
                Manual Processing
              </TabsTrigger>
            </TabsList>
            <TabsContent value={PaymentProcessingMethod.AUTO} className='mt-6'>
              <PaymentProcessing type={PaymentProcessingMethod.AUTO} />
            </TabsContent>
            <TabsContent value={PaymentProcessingMethod.MANUAL} className='mt-6'>
              <ManualProcessingTab defaultSubTab={manualSubTab} />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </>
  );
}
